/**
 * 点呼内容マスタ設定ページ用のスクリプト
 */
if (is_route('rollcall_content.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function () {
        rollcall_content_event_set();
    });
}

// 設定モーダルを開いた時点のフォーム状態スナップショット（戻る時の変更検知用）
var rollcall_content_form_snapshot = null;

/**
 * ページ読み込み時のイベント設定
 */
window.rollcall_content_event_set = function () {

    /*---- 設定表示時 ----*/

    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true, function () {
            var $inputType = $('#rollcall_content-setting-modal-input_type');
            if ($inputType.length) {
                rollcall_content_toggle_preset($inputType[0]);
            }
            // 必須充足状態を保存ボタンへ反映
            rollcall_content_update_save_button();
            // toggle 後の状態を初期スナップショットとして保持する
            rollcall_content_form_snapshot = rollcall_content_form_state();
        });
    });

    /*---- input_type 切り替えで preset_type を表示/非表示 ----*/

    $(document).on('change', '[data-rollcall-content-input-type]', function () {
        rollcall_content_toggle_preset(this);
    });

    /*---- 必須項目の入力監視 → 保存ボタンの活性/非活性 ----*/

    $(document).on('input change', '#rollcall_content-setting-modal-form :input', function () {
        rollcall_content_update_save_button();
    });

    /*---- 戻るボタン: 変更ありなら破棄確認、なければそのまま閉じる ----*/

    $(document).on('click', '[data-rollcall-content-back]', function () {
        // スナップショット未取得（防衛）または変更なしなら、確認を出さず即閉じる。
        if (rollcall_content_form_snapshot === null
            || rollcall_content_form_state() === rollcall_content_form_snapshot) {
            _modal.hide('#rollcall_content-setting-modal');
            return;
        }
        // 変更あり: 設定モーダルは開いたまま、破棄確認を上に重ねて表示する。
        // z-index / backdrop の積み上げ、ESC を最前面へ振り分ける処理、フォーカス移動は
        // common/initialize.js のモーダルスタック管理が担当する。
        $('#rollcall_content-discard_confirm-modal').modal('show');
    });

    /*---- 破棄確認「破棄して閉じる」: 破棄確認と設定モーダルの両方を閉じて一覧へ ----*/
    /*
     * 「戻る」「×」「ESC」で破棄確認だけを閉じた場合は、下の設定モーダルがそのまま残るため、
     * 編集内容を保持したまま編集を続けられる（再表示の制御は不要）。
     */

    $(document).on('click', '[data-rollcall-content-discard]', function () {
        $('#rollcall_content-discard_confirm-modal').modal('hide');
        _modal.hide('#rollcall_content-setting-modal');
    });

    /*---- 保存確認 → 保存 ----*/

    $(document).on('click', '[data-save-modal]', function () {
        var $btn = $(this);
        var confirmAction = $btn.data('confirm-action');
        if (!confirmAction) {
            // 念のため fallback
            _modal.submit(this, 'save-modal');
            return;
        }
        rollcall_content_request_confirm(confirmAction);
    });

    /*---- 確認ダイアログ「保存」(はい) ----*/

    $(document).on('click', '[data-save-confirm-continue]', function () {
        var settingModalSelector = $(this).data('save-confirm-continue');
        var $form = $(settingModalSelector + '-form');
        // 確認 modal を閉じてから保存
        $('#rollcall_content-save_confirm-modal').modal('hide');
        rollcall_content_submit_form($form);
    });

    /*---- 確認ダイアログを閉じる直前、配下のフォーカスを外す ----*/

    // ボタン等にフォーカスが残ったまま modal に aria-hidden が付くと、ブラウザが
    // 「フォーカス中の要素を支援技術から隠すな」と警告する。保存確認・破棄確認の
    // いずれも、閉じ方（はい/いいえ/戻る/破棄/×）に関わらず hide 直前に発火する
    // hide.bs.modal でフォーカスを外す。
    $(document).on('hide.bs.modal', '#rollcall_content-save_confirm-modal, #rollcall_content-discard_confirm-modal', function () {
        var active = document.activeElement;
        if (active && active !== this && this.contains(active)) {
            active.blur();
        }
    });
};

/**
 * 設定モーダルのフォーム状態を文字列で返す（戻る時の変更検知用）。
 * disabled 項目は serialize() に含まれないため、編集時は EDITABLE_COLUMNS 相当の差分になる。
 */
window.rollcall_content_form_state = function () {
    return $('#rollcall_content-setting-modal-form').serialize();
};

/**
 * 必須項目の充足状況を見て保存ボタンの活性/非活性を切り替える。
 *
 * 必須: 項目名(label) / 凡例(legend_label) / 入力形式(input_type) / アクティブフラグ(is_active)。
 * preset_type は input_type が選択系（preset 必須）のときのみ追加で必須。
 */
window.rollcall_content_update_save_button = function () {
    var $form = $('#rollcall_content-setting-modal-form');
    if (!$form.length) {
        return;
    }
    var label = $.trim($('#rollcall_content-setting-modal-label').val() || '');
    var legend_label = $.trim($('#rollcall_content-setting-modal-legend_label').val() || '');
    var inputType = $('#rollcall_content-setting-modal-input_type').val() || '';
    var hasActive = $form.find('input[name="is_active"]:checked').length > 0;
    var valid = label !== '' && legend_label !== '' && inputType !== '' && hasActive;
    // preset_type は input_type が選択系のときのみ必須
    var presetRequiredTypes = $('[data-rollcall-content-preset-block]').data('rollcall-content-preset-required-input-types') || [];
    if (presetRequiredTypes.indexOf(inputType) !== -1) {
        var presetVal = $('#rollcall_content-setting-modal-preset_type').val() || '';
        valid = valid && presetVal !== '';
    }
    $('[data-save-modal]').prop('disabled', !valid);
};

/**
 * input_type の値からプリセット必須かを判定し preset_type を切り替える
 *
 * preset 必須となる input_type キー一覧は config/system/rollcall_content.php を
 * 出元とし、blade の data-rollcall-content-preset-required-input-types 属性経由で渡る。
 */
window.rollcall_content_toggle_preset = function (inputTypeEl) {
    var $inputType = $(inputTypeEl);
    var value = $inputType.val();
    var $block = $('[data-rollcall-content-preset-block]');
    var $preset = $('#rollcall_content-setting-modal-preset_type');
    var initialDisabled = $preset.data('rollcall-content-initial-disabled');
    if (typeof initialDisabled === 'undefined') {
        initialDisabled = $preset.prop('disabled');
        $preset.data('rollcall-content-initial-disabled', initialDisabled);
    }
    var presetRequiredTypes = $block.data('rollcall-content-preset-required-input-types') || [];
    var presetRequired = presetRequiredTypes.indexOf(value) !== -1;
    if (presetRequired) {
        if (!$preset.val()) {
            $preset.val($preset.find('option:first').val());
        }
        $block.show();
        $preset.prop('disabled', initialDisabled);
        $preset.trigger('change');
    } else {
        $preset.prop('disabled', true);
        $block.hide();
    }
};

/**
 * 保存確認 AJAX → 結果に応じて modal を切り替える
 *
 * status: confirm（新規）/ warning（編集・差分あり）/ no_change（編集・差分なし）
 */
window.rollcall_content_request_confirm = function (confirmAction) {
    var $form = $('#rollcall_content-setting-modal-form');
    // 送信前にエラーをリセット（_modal.submit と同じ挙動。独自AJAX経路のためここで明示的に呼ぶ）
    _error.reset();
    var data = $form.serializeArray();
    $.ajax({
        url: confirmAction,
        method: 'POST',
        data: data,
    }).done(function (res) {
        if (!res || !res.status) {
            rollcall_content_submit_form($form);
            return;
        }
        if (res.status === 'no_change') {
            $('#rollcall_content-save_confirm-modal .modal-content').html(res.html);
            _modal.show('#rollcall_content-save_confirm-modal');
            return;
        }
        if (res.status === 'warning' || res.status === 'confirm') {
            $('#rollcall_content-save_confirm-modal .modal-content').html(res.html);
            _modal.show('#rollcall_content-save_confirm-modal');
            return;
        }
        // 想定外 status は fallback で送信
        rollcall_content_submit_form($form);
    }).fail(function (xhr, status, errorThrown) {
        rollcall_content_handle_error(xhr, status, errorThrown);
    });
};

/**
 * 保存系 ajax の失敗時処理。
 *
 * 各入力欄へのエラー配置は共通処理（_error.set）に任せるが、トーストは
 * 「エラー内容を確認して下さい。」の汎用文言だけで内容が分からないため、
 * showToast=false で共通のトーストを抑止し、代わりに内容を箇条書きしたトーストを出す。
 */
window.rollcall_content_handle_error = function (xhr, status, errorThrown) {
    _error.set('#rollcall_content-setting-modal', xhr, status, errorThrown, false);

    // 400（バリデーション）以外は _error.set 側がシステムエラー表示まで行うため、ここでは何もしない。
    if (xhr.status !== 400) {
        return;
    }
    // _error.set が responseText からのパースまで行うため、この時点で responseJSON が使える。
    var json = xhr.responseJSON;
    if (!json) {
        return;
    }

    var subject = _.escape(json.subject || '');
    var items = [];
    $.each(json.errors || {}, function (name, messages) {
        $.each([].concat(messages), function (i, message) {
            items.push('<li>' + _.escape(message) + '</li>');
        });
    });

    if (items.length === 0) {
        toastr.warning(subject);
        return;
    }
    // toastr は既定で escapeHtml:false のため HTML を渡せる（各メッセージは escape 済み）。
    toastr.warning('<ul class="mb-0 pl-3">' + items.join('') + '</ul>', subject);
};

/**
 * setting modal の form を送信する
 */
window.rollcall_content_submit_form = function ($form) {
    var action = $form.attr('action');
    var data = $form.serializeArray();
    $.ajax({
        url: action,
        method: 'POST',
        data: data,
    }).done(function (res) {
        _complete.set(res);
        _modal.hide('#rollcall_content-setting-modal');
        load_contents();
    }).fail(function (xhr, status, errorThrown) {
        rollcall_content_handle_error(xhr, status, errorThrown);
    });
};
